import { useState, useEffect } from "react";

// ─── REAL DATABASE via PHP API on your server ─────────────────────────────────
// Data saved as files on agromulticultivation.com — works on ALL devices!
const DB_API = "https://agromulticultivation.com/amc-api/amc-db.php";

async function dbGet(k) { 
  try { 
    const r = await fetch(DB_API, {
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body: JSON.stringify({action:"get", key:k})
    });
    const d = await r.json();
    return d.success && d.value ? JSON.parse(d.value) : null;
  } catch { 
    // Fallback to localStorage if server unreachable
    try { const v=localStorage.getItem(k); return v?JSON.parse(v):null; } catch { return null; }
  }
}

async function dbSet(k, v) { 
  try { 
    await fetch(DB_API, {
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body: JSON.stringify({action:"set", key:k, value:JSON.stringify(v)})
    });
    // Also save to localStorage as backup
    try { localStorage.setItem(k, JSON.stringify(v)); } catch {}
  } catch {
    // Fallback to localStorage
    try { localStorage.setItem(k, JSON.stringify(v)); } catch {}
  }
}
const EMAIL_API = "https://agromulticultivation.com/amc-api/send_email.php";

async function sendEmailAPI(type, email, name, accId, tempPw) {
  try {
    const res = await fetch(EMAIL_API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ type, email, name, accId, tempPw }),
    });
    const data = await res.json();
    return data;
  } catch (e) {
    return { success: false, message: e.message };
  }
}

// ─── EXCEL EXPORT ─────────────────────────────────────────────────────────────
function exportCustomersExcel(customers, plans) {
  // Build CSV rows (Excel opens CSV perfectly)
  const rows = [];
  // Header
  rows.push([
    "Account ID","Full Name","Email","Phone","Password","Temp PW",
    "Plan","Deposit Amount (LKR)","Deposit Date","Plan End Date",
    "Monthly Harvest (LKR)","Total Harvest (LKR)","Harvest Paid So Far (LKR)",
    "Months Paid","Total Months","Status"
  ]);
  Object.values(customers).forEach(c => {
    if (c.deposits.length === 0) {
      rows.push([c.id,c.name,c.email,c.phone,c.password,c.tempPassword?"YES":"NO",
        "","","","","","","","","",""]);
    } else {
      c.deposits.forEach((dep,i) => {
        const p = plans[dep.planKey] || {};
        const mh = dep.amount * (p.ratePerYear||0) / 100 / 12;
        const th = dep.amount * (p.ratePerYear||0) / 100 * (p.years||0);
        const me = (() => { const s=new Date(dep.depositDate),t=new Date(); let m=(t.getFullYear()-s.getFullYear())*12+(t.getMonth()-s.getMonth()); if(t.getDate()>=s.getDate())m++; return Math.max(0,Math.min(m,(p.years||0)*12)); })();
        const paid = mh * me;
        const dLeft = Math.ceil((new Date(dep.harvestDate)-new Date())/86400000);
        const status = dLeft<0?"Plan Ended":dLeft<=30?"Maturing Soon":"Active";
        rows.push([
          i===0?c.id:"", i===0?c.name:"", i===0?c.email:"",
          i===0?c.phone:"", i===0?c.password:"", i===0?(c.tempPassword?"YES":"NO"):"",
          `${p.label||""} ${p.years||""}Y ${p.ratePerYear||""}%/yr`,
          dep.amount, dep.depositDate, dep.harvestDate,
          Math.round(mh), Math.round(th), Math.round(paid),
          me, (p.years||0)*12, status
        ]);
      });
    }
  });
  const csv = rows.map(r => r.map(cell => `"${String(cell).replace(/"/g,'""')}"`).join(",")).join("\n");
  const bom = "\uFEFF"; // UTF-8 BOM for Excel
  const blob = new Blob([bom + csv], { type: "text/csv;charset=utf-8;" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `AMC_Customers_${new Date().toISOString().split("T")[0]}.csv`;
  a.click();
}

function exportAlertsExcel(alerts) {
  const rows = [];
  rows.push(["Customer ID","Customer Name","Phone","Plan","Amount (LKR)","Plan End Date","Days Left","Type","SMS Sent","SMS Sent At","Created At"]);
  alerts.forEach(a => {
    rows.push([
      a.customerId, a.customerName, a.phone,
      a.planKey||"", a.amount, a.harvestDate, a.daysLeft,
      a.type, a.sentSms?"YES":"NO", a.smsSentAt||"", a.createdAt||""
    ]);
  });
  const csv = rows.map(r => r.map(cell => `"${String(cell||"").replace(/"/g,'""')}"`).join(",")).join("\n");
  const bom = "\uFEFF";
  const blob = new Blob([bom + csv], { type: "text/csv;charset=utf-8;" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `AMC_Alerts_${new Date().toISOString().split("T")[0]}.csv`;
  a.click();
}

// ─── STAFF MEMBERS (stored in persistent storage) ────────────────────────────
const DEFAULT_STAFF = [
  { id:"S001", name:"Admin", role:"admin", pin:"1993" },
  { id:"S002", name:"Ayon",  role:"staff", pin:"2025" },
];
// Roles: "admin" = full access including staff management
//        "staff" = all features except staff management tab
const PLANS = {
  "Silver-1Y":{ label:"Silver Plan", years:1, ratePerYear:40 },
  "Silver-2Y":{ label:"Silver Plan", years:2, ratePerYear:42 },
  "Gold-3Y":  { label:"Gold Plan",   years:3, ratePerYear:45 },
  "Gold-5Y":  { label:"Gold Plan",   years:5, ratePerYear:45 },
};
const PLAN_OPTIONS = [
  {key:"Silver-1Y",label:"🥈 Silver Plan · 1 Year · 40%/yr"},
  {key:"Silver-2Y",label:"🥈 Silver Plan · 2 Years · 42%/yr"},
  {key:"Gold-3Y",  label:"🥇 Gold Plan · 3 Years · 45%/yr"},
  {key:"Gold-5Y",  label:"🥇 Gold Plan · 5 Years · 45%/yr"},
];

// Monthly harvest = deposit × ratePerYear/100/12
const monthlyHarvest      = d => { const p=PLANS[d.planKey]; return p ? d.amount*(p.ratePerYear/100/12) : 0; };
const totalHarvestAtEnd   = d => { const p=PLANS[d.planKey]; return p ? d.amount*(p.ratePerYear/100)*p.years : 0; };
const monthsElapsed       = date => { const s=new Date(date),t=new Date(); let m=(t.getFullYear()-s.getFullYear())*12+(t.getMonth()-s.getMonth()); if(t.getDate()>=s.getDate())m++; return Math.max(0,m); };
const harvestPaidSoFar    = d => { const p=PLANS[d.planKey]; return p ? monthlyHarvest(d)*Math.min(monthsElapsed(d.depositDate),p.years*12) : 0; };
const nextHarvestDate     = date => { const t=new Date(),s=new Date(date),day=s.getDate(),n=new Date(t.getFullYear(),t.getMonth(),day); if(n<=t)n.setMonth(n.getMonth()+1); return n.toISOString().split("T")[0]; };
const calcHarvestDate     = (date,pk) => { const p=PLANS[pk]; if(!p) return date; const d=new Date(date); d.setFullYear(d.getFullYear()+p.years); return d.toISOString().split("T")[0]; };
const planProgress        = d => { const s=new Date(d.depositDate),e=new Date(d.harvestDate),n=new Date(); return Math.min(100,Math.max(0,(n-s)/(e-s)*100)); };
const depositStatus       = d => { const x=Math.ceil((new Date(d.harvestDate)-new Date())/86400000); return x<0?"Plan Ended":x<=30?"Maturing Soon":"Active"; };
const nextId              = cs => { const n=Object.keys(cs).map(k=>parseInt(k.split("-")[1])).filter(Boolean); return `AMC-${String((n.length?Math.max(...n):0)+1).padStart(3,"0")}`; };
const generateTempPw      = () => { const c="ABCDEFGHJKMNPQRSTUVWXYZ23456789"; return "AMC-"+Array.from({length:6},()=>c[Math.floor(Math.random()*c.length)]).join(""); };

// ─── NO DEMO DATA — starts empty ──────────────────────────────────────────────
const SEED = {};

// ─── BRAND ────────────────────────────────────────────────────────────────────
const B={red:"#8B1A2B",redD:"#6B1220",gold:"#C9A020",goldL:"#E8C840",green:"#3A7D44",greenL:"#4CAF61",blue:"#2B5BA8",dark:"#2D2D2D",white:"#FFFFFF",bg:"#F5F5F5",sidebar:"#1C1C2E",card:"#FFFFFF",border:"#E8E8E8",muted:"#888888"};
const fmt=n=>new Intl.NumberFormat("en-LK",{style:"currency",currency:"LKR",maximumFractionDigits:0}).format(n);
const fmtDate=d=>new Date(d).toLocaleDateString("en-GB",{day:"2-digit",month:"short",year:"numeric"});

function AMCIcon({size=36}){return <img src="/LOGO_AMC.png" style={{width:size,height:"auto",display:"block"}} alt="AMC"/>;}
function AMCLogo({height=32}){return <img src="/LOGO_AMC.png" style={{height,width:"auto",display:"block"}} alt="AMC Logo"/>;}

function PlanBadge({planKey}){
  const p=PLANS[planKey];if(!p)return null;
  const g=planKey.startsWith("Gold");
  return <span style={{background:g?"#FEF3C7":"#F3F4F6",color:g?"#92400E":"#374151",border:`1.5px solid ${g?"#F59E0B":"#D1D5DB"}`,borderRadius:20,padding:"3px 12px",fontSize:12,fontWeight:700,display:"inline-flex",alignItems:"center",gap:4}}>
    {g?"🥇":"🥈"} {p.label} · {p.years}Y · {p.ratePerYear}%/yr
  </span>;
}
function StatusBadge({status}){
  const s=status==="Plan Ended"?{bg:"#FFF0F0",c:B.red,icon:"⛔"}:status==="Maturing Soon"?{bg:"#FFFBEC",c:B.gold,icon:"⏳"}:{bg:"#F0FFF4",c:B.green,icon:"✅"};
  return <span style={{background:s.bg,color:s.c,border:`1.5px solid ${s.c}30`,borderRadius:20,padding:"3px 11px",fontSize:11,fontWeight:700}}>{s.icon} {status}</span>;
}

function Modal({title,onClose,children}){
  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:999,display:"flex",alignItems:"center",justifyContent:"center",padding:20,backdropFilter:"blur(4px)"}} onClick={e=>e.target===e.currentTarget&&onClose()}>
    <div style={{background:B.white,borderRadius:22,padding:28,width:"100%",maxWidth:540,maxHeight:"92vh",overflowY:"auto",boxShadow:"0 20px 60px rgba(0,0,0,0.2)"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <h3 style={{color:B.dark,margin:0,fontSize:18,fontWeight:700}}>{title}</h3>
        <button onClick={onClose} style={{background:"#F5F5F5",border:"none",color:B.muted,borderRadius:"50%",width:32,height:32,cursor:"pointer",fontSize:16,display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
      </div>
      {children}
    </div>
  </div>;
}

function Field({label,name,type="text",value,onChange,placeholder,step}){
  const [show,setShow]=useState(false);
  const isP=type==="password";
  const inp={width:"100%",padding:"10px 14px",borderRadius:10,border:`1.5px solid ${B.border}`,background:"#FAFAFA",color:B.dark,fontSize:14,outline:"none",boxSizing:"border-box",fontFamily:"inherit",paddingRight:isP?44:14};
  return <div style={{marginBottom:15}}>
    <label style={{color:B.muted,fontSize:12,fontWeight:600,display:"block",marginBottom:5,letterSpacing:0.5}}>{label}</label>
    <div style={{position:"relative"}}>
      <input type={isP&&show?"text":type} value={value} step={step} placeholder={placeholder} onChange={e=>onChange(name,e.target.value)} style={inp}/>
      {isP&&<button type="button" onClick={()=>setShow(p=>!p)} style={{position:"absolute",right:12,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",color:B.muted,cursor:"pointer",fontSize:15,padding:0}}>{show?"🙈":"👁"}</button>}
    </div>
  </div>;
}

// ─── MAIN ─────────────────────────────────────────────────────────────────────
export default function StaffPortal(){
  const [customers,setCustomers]=useState(null);
  const [alerts,setAlerts]=useState([]);
  const [smsConfig,setSmsConfig]=useState({username:"",apiToken:"",senderId:"AMC",configured:false});
  const [staffMembers,setStaffMembers]=useState(null);
  const [loggedInStaff,setLoggedInStaff]=useState(null);
  const [loading,setLoading]=useState(true);
  const [view,setView]=useState("login");
  const [tab,setTab]=useState("dashboard");
  const [selectedStaffId,setSelectedStaffId]=useState("");
  const [pin,setPin]=useState("");
  const [pinErr,setPinErr]=useState("");
  const [selected,setSelected]=useState(null);
  const [searchQ,setSearchQ]=useState("");
  const [modal,setModal]=useState(null);
  const [form,setForm]=useState({});
  const [toast,setToast]=useState(null);
  const [smsSending,setSmsSending]=useState({});
  const [showPw,setShowPw]=useState({});
  const [createdPw,setCreatedPw]=useState(null);

  useEffect(()=>{
    (async()=>{
      const [c,a,s,st] = await Promise.all([
        dbGet("amc-customers-v4"),
        dbGet("amc-alerts-v4"),
        dbGet("amc-sms-config"),
        dbGet("amc-staff-v2"),
      ]);
      const loaded = c && Object.keys(c).length > 0 ? c : null;
      setCustomers(loaded || SEED);
      setAlerts(a||[]);
      if(s) setSmsConfig(s);
      setStaffMembers(st && st.length > 0 ? st : DEFAULT_STAFF);
      setDataLoaded(true);
      setLoading(false);
    })();
  },[]);
  const [dataLoaded, setDataLoaded] = useState(false);
  useEffect(()=>{ 
    if(dataLoaded && customers && Object.keys(customers).length > 0) {
      dbSet("amc-customers-v4",customers); 
    }
  },[customers, dataLoaded]);
  useEffect(()=>{ if(dataLoaded) dbSet("amc-alerts-v4",alerts); },[alerts, dataLoaded]);
  useEffect(()=>{ dbSet("amc-sms-config",smsConfig); },[smsConfig]);
  useEffect(()=>{ 
    if(staffMembers && staffMembers.length > 0){
      const merged = [...DEFAULT_STAFF, ...staffMembers.filter(s=>!DEFAULT_STAFF.find(d=>d.name.toLowerCase()===s.name.toLowerCase()))];
      dbSet("amc-staff-v2", merged);
    }
  },[staffMembers]);

  const [loginStaffList, setLoginStaffList] = useState(DEFAULT_STAFF);

  // Every time login screen shows, load fresh staff list from server
  useEffect(()=>{
    if(view==="login"){
      (async()=>{
        const st = await dbGet("amc-staff-v2");
        if(st && st.length > 0){
          const merged = [...DEFAULT_STAFF, ...st.filter(s=>!DEFAULT_STAFF.find(d=>d.name.toLowerCase()===s.name.toLowerCase()))];
          setLoginStaffList(merged);
        } else {
          setLoginStaffList(DEFAULT_STAFF);
        }
      })();
    }
  },[view]);

  function showToast(msg,type="success"){ setToast({msg,type}); setTimeout(()=>setToast(null),4500); }

  function handleStaffLogin(){
    if(!selectedStaffId.trim()){ setPinErr("Please select your name."); return; }
    if(!pin.trim()){ setPinErr("Please enter your PIN."); return; }
    const found = loginStaffList.find(s=>
      s.name.toLowerCase()===selectedStaffId.trim().toLowerCase() && s.pin===pin.trim()
    );
    if(!found){ 
      setPinErr("Incorrect PIN. Please try again."); 
      return; 
    }
    setLoggedInStaff(found);
    setView("portal");
    setPinErr("");
    setPin("");
    setSelectedStaffId("");
  }

  function handleLogout(){
    setLoggedInStaff(null);
    setView("login");
    setTab("dashboard");
    setSelected(null);
    setPin("");
    setSelectedStaffId("");
  }

  const isAdmin = loggedInStaff?.role==="admin";

  // Auto-generate alerts
  useEffect(()=>{
    if(!customers)return;
    Object.values(customers).forEach(c=>c.deposits.forEach(dep=>{
      const d=Math.ceil((new Date(dep.harvestDate)-new Date())/86400000);
      if([30,7,3,0].includes(d)||(d<0&&d>=-60)){
        const key=`${c.id}-${dep.id}-d${d}`;
        setAlerts(prev=>{ if(prev.find(a=>a.key===key))return prev;
          return [{key,id:Date.now()+Math.random(),customerId:c.id,customerName:c.name,phone:c.phone,depositId:dep.id,amount:dep.amount,planKey:dep.planKey,harvestDate:dep.harvestDate,daysLeft:d,type:d<0?"ended":d===0?"today":"upcoming",sentSms:false},...prev];
        });
      }
    }));
  },[customers]);

  function saveCustomer(data){ setCustomers(p=>({...p,[data.id]:data})); }

  function delCustomer(id){
    if(!confirm(`Delete ${id}? Cannot be undone.`))return;
    setCustomers(p=>{ const n={...p};delete n[id];return n; });
    if(selected?.id===id)setSelected(null);
    showToast("Customer deleted.");
  }

  function addDeposit(cid,dep){
    setCustomers(p=>{
      const c={...p[cid]};
      const ids=c.deposits.map(d=>parseInt(d.id.replace("D",""))).filter(Boolean);
      c.deposits=[...c.deposits,{...dep,id:"D"+((ids.length?Math.max(...ids):0)+1)}];
      if(selected?.id===cid)setSelected(c);
      return{...p,[cid]:c};
    }); showToast("Plan added!");
  }

  function updateDeposit(cid,did,data){
    setCustomers(p=>{
      const c={...p[cid],deposits:p[cid].deposits.map(d=>d.id===did?{...d,...data}:d)};
      if(selected?.id===cid)setSelected(c);
      return{...p,[cid]:c};
    }); showToast("Updated!");
  }

  function delDeposit(cid,did){
    if(!confirm("Delete this plan?"))return;
    setCustomers(p=>{
      const c={...p[cid],deposits:p[cid].deposits.filter(d=>d.id!==did)};
      if(selected?.id===cid)setSelected(c);
      return{...p,[cid]:c};
    }); showToast("Deleted.");
  }

  function resetCustomerPw(id){
    const pw=generateTempPw();
    const updated={...customers[id],password:pw,tempPassword:true};
    saveCustomer(updated);
    if(selected?.id===id)setSelected(updated);
    // Send password reset email
    sendEmailAPI("password_reset",updated.email,updated.name,id,pw).then(r=>{
      if(r.success) showToast(`✅ Password reset! Email sent to ${updated.email}`);
      else showToast(`✅ Password reset to: ${pw} (Email failed: ${r.message})`,"info");
    });
    return pw;
  }

  async function sendSMS(alert){
    if(!smsConfig.configured)return showToast("Configure SMS in Admin first.","error");
    setSmsSending(p=>({...p,[alert.id]:true}));
    const plan=PLANS[alert.planKey];
    const mh=monthlyHarvest({amount:alert.amount,planKey:alert.planKey});
    const d=alert.daysLeft;
    const msg=d<0
      ?`Dear ${alert.customerName}, your AMC ${plan?.label||""} plan of ${fmt(alert.amount)} has ended. Your deposit is ready for withdrawal. Call +94117409509. Agro Multi Cultivation (Pvt) Ltd.`
      :d===0?`Dear ${alert.customerName}, your AMC plan ends TODAY. Monthly harvest: ${fmt(mh)}. Call +94117409509. Agro Multi Cultivation.`
      :`Dear ${alert.customerName}, your AMC ${plan?.label||""} plan (${fmt(alert.amount)}) ends in ${d} days. Monthly harvest: ${fmt(mh)}. Call +94117409509. Agro Multi Cultivation.`;
    try {
      const phone=alert.phone.replace(/^0/,"94").replace(/[^0-9]/g,"");
      // Step 1: Login to get bearer token
      const loginRes=await fetch("https://esms.dialog.lk/api/v2/user/login",{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({username:smsConfig.username,password:smsConfig.apiToken})
      });
      const loginData=await loginRes.json();
      if(!loginData.token)throw new Error("Login failed: "+JSON.stringify(loginData));
      // Step 2: Send SMS
      const res=await fetch("https://esms.dialog.lk/api/v2/send/sms",{
        method:"POST",
        headers:{"Content-Type":"application/json",Authorization:`Bearer ${loginData.token}`},
        body:JSON.stringify({
          msisdn:[{mobile:phone}],
          sourceAddress:smsConfig.senderId,
          message:msg,
          transaction_id:Date.now(),
          payment_method:0
        })
      });
      const data=await res.json();
      if(data.status==="error")throw new Error(data.message);
      setAlerts(p=>p.map(a=>a.id===alert.id?{...a,sentSms:true,smsSentAt:new Date().toISOString()}:a));
      showToast(`✅ SMS sent to ${alert.phone}`);
    } catch(e){ showToast(`❌ SMS failed: ${e.message}`,"error"); }
    setSmsSending(p=>({...p,[alert.id]:false}));
  }

  const customerList=Object.values(customers||{});
  const allDeps=customerList.flatMap(c=>c.deposits);
  const totalFunds=allDeps.reduce((a,d)=>a+d.amount,0);
  const totalMonthlyOut=allDeps.reduce((a,d)=>a+monthlyHarvest(d),0);
  const totalHarvestPaidOut=allDeps.reduce((a,d)=>a+harvestPaidSoFar(d),0);
  const pendingAlerts=alerts.filter(a=>!a.sentSms);
  const filteredCustomers=customerList.filter(c=>
    c.name.toLowerCase().includes(searchQ.toLowerCase())||
    c.id.toLowerCase().includes(searchQ.toLowerCase())||
    c.phone.includes(searchQ)||
    c.email.toLowerCase().includes(searchQ.toLowerCase())
  );

  const inpStyle={width:"100%",padding:"10px 14px",borderRadius:10,border:`1.5px solid ${B.border}`,background:"#FAFAFA",color:B.dark,fontSize:14,outline:"none",boxSizing:"border-box",fontFamily:"inherit"};
  const btnP={background:`linear-gradient(135deg,${B.red},${B.redD})`,color:B.white,border:"none",borderRadius:10,padding:"9px 20px",cursor:"pointer",fontWeight:700,fontSize:14,fontFamily:"inherit",boxShadow:`0 2px 10px ${B.red}40`};

  // ── CUSTOMER DETAIL ──────────────────────────────────────────────────────
  function CustomerDetail({c}){
    const totalDep=c.deposits.reduce((a,d)=>a+d.amount,0);
    const totalRet=c.deposits.reduce((a,d)=>a+totalHarvestAtEnd(d),0);
    const totalMth=c.deposits.reduce((a,d)=>a+monthlyHarvest(d),0);
    const totalPaid=c.deposits.reduce((a,d)=>a+harvestPaidSoFar(d),0);
    const withdrawable=c.deposits.filter(d=>depositStatus(d)==="Plan Ended").reduce((a,d)=>a+d.amount,0);

    return <div>
      {/* Info */}
      <div style={{background:B.card,border:`1px solid ${B.border}`,borderRadius:18,padding:24,marginBottom:18,boxShadow:"0 2px 12px rgba(0,0,0,0.06)"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:12}}>
          <div>
            <div style={{color:B.muted,fontSize:11,letterSpacing:1.5,fontWeight:600,marginBottom:4}}>ACCOUNT</div>
            <div style={{color:B.red,fontSize:22,fontWeight:800}}>{c.name}</div>
            <div style={{color:B.muted,fontSize:13,marginTop:2}}>{c.id} · 📱 {c.phone}</div>
            <div style={{color:B.muted,fontSize:12}}>✉️ {c.email}</div>

            {/* Password row */}
            <div style={{marginTop:12,padding:"10px 12px",background:"#F9FAFB",borderRadius:10,border:`1px solid ${B.border}`}}>
              <div style={{color:B.muted,fontSize:11,fontWeight:600,marginBottom:6,letterSpacing:0.5}}>APP LOGIN PASSWORD</div>
              <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                <code style={{color:showPw[c.id]?B.dark:B.muted,fontSize:15,background:"#F0F0F0",borderRadius:6,padding:"3px 10px",letterSpacing:1,border:`1px solid ${B.border}`}}>
                  {showPw[c.id]?c.password:"••••••••"}
                </code>
                {c.tempPassword&&<span style={{background:"#FFF3CD",color:"#856404",fontSize:11,fontWeight:700,borderRadius:6,padding:"2px 8px",border:"1px solid #FFECB5"}}>TEMP</span>}
                <button onClick={()=>setShowPw(p=>({...p,[c.id]:!p[c.id]}))} style={{background:"transparent",border:`1.5px solid ${B.border}`,color:B.muted,borderRadius:7,padding:"3px 10px",cursor:"pointer",fontSize:12}}>{showPw[c.id]?"Hide":"Show"}</button>
                <button onClick={()=>{const pw=resetCustomerPw(c.id);setCreatedPw({name:c.name,email:c.email,pw});}} style={{background:`${B.red}10`,border:`1.5px solid ${B.red}30`,color:B.red,borderRadius:7,padding:"3px 10px",cursor:"pointer",fontSize:12}}>Reset PW</button>
              </div>
            </div>
          </div>
          <div style={{display:"flex",gap:8}}>
            <button onClick={()=>{setForm({...c});setModal("editCustomer");}} style={{...btnP,padding:"8px 16px"}}>Edit</button>
            <button onClick={()=>delCustomer(c.id)} style={{background:"transparent",border:`1.5px solid ${B.red}40`,color:B.red,borderRadius:10,padding:"8px 16px",cursor:"pointer",fontSize:13}}>Delete</button>
          </div>
        </div>

        {/* Withdrawal alert */}
        {withdrawable>0&&<div style={{marginTop:14,background:`linear-gradient(135deg,${B.red},${B.redD})`,borderRadius:12,padding:"12px 16px",color:B.white}}>
          <div style={{fontWeight:700,fontSize:14}}>⛔ Withdrawal Available: {fmt(withdrawable)}</div>
          <div style={{fontSize:12,opacity:0.9,marginTop:3}}>One or more plans ended. Customer can withdraw deposit principal.</div>
        </div>}

        {/* Stats */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:10,marginTop:16,paddingTop:14,borderTop:`1px solid ${B.border}`}}>
          {[
            {l:"TOTAL DEPOSITED",  v:fmt(totalDep), c:B.dark},
            {l:"TOTAL HARVEST",    v:fmt(totalRet), c:B.green},
            {l:"MONTHLY HARVEST",  v:fmt(totalMth), c:B.gold},
            {l:"HARVEST PAID",     v:fmt(totalPaid),c:B.blue},
          ].map(s=><div key={s.l} style={{background:`${s.c}08`,borderRadius:10,padding:"10px 12px",border:`1px solid ${s.c}18`}}>
            <div style={{color:B.muted,fontSize:10,letterSpacing:1.2,marginBottom:4,fontWeight:600}}>{s.l}</div>
            <div style={{color:s.c,fontSize:15,fontWeight:800}}>{s.v}</div>
          </div>)}
        </div>
      </div>

      {/* Plans header */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
        <div style={{color:B.muted,fontWeight:700,fontSize:12,letterSpacing:1.5}}>INVESTMENT PLANS</div>
        <button onClick={()=>{setForm({customerId:c.id,amount:"",depositDate:"",planKey:"Silver-1Y",harvestDate:""});setModal("addDeposit");}} style={btnP}>+ Add Plan</button>
      </div>

      {c.deposits.length===0
        ?<div style={{color:B.muted,textAlign:"center",padding:40,background:B.card,borderRadius:14,border:`1px solid ${B.border}`}}>No plans yet.</div>
        :c.deposits.map(dep=>{
          const plan=PLANS[dep.planKey]||{};
          const st=depositStatus(dep);
          const prog=planProgress(dep);
          const mh=monthlyHarvest(dep);
          const paid=harvestPaidSoFar(dep);
          const mp=Math.min(monthsElapsed(dep.depositDate),(plan.years||0)*12);
          const totalM=(plan.years||0)*12;
          const dLeft=Math.ceil((new Date(dep.harvestDate)-new Date())/86400000);
          const canW=st==="Plan Ended";
          const isGold=dep.planKey?.startsWith("Gold");
          const nextHv=nextHarvestDate(dep.depositDate);

          return <div key={dep.id} style={{background:B.card,border:`1.5px solid ${canW?B.red:B.border}`,borderRadius:16,padding:20,marginBottom:14,boxShadow:"0 2px 10px rgba(0,0,0,0.05)"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:14}}>
              <div>
                <div style={{marginBottom:6}}><PlanBadge planKey={dep.planKey}/></div>
                <div style={{color:B.dark,fontWeight:800,fontSize:20}}>{fmt(dep.amount)}</div>
                <div style={{color:B.muted,fontSize:12,marginTop:2}}>Start: {fmtDate(dep.depositDate)} · End: {fmtDate(dep.harvestDate)}</div>
              </div>
              <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:7}}>
                <StatusBadge status={st}/>
                <div style={{display:"flex",gap:6}}>
                  <button onClick={()=>{setForm({customerId:c.id,...dep});setModal("editDeposit");}} style={{background:"#F5F5F5",border:`1px solid ${B.border}`,color:B.dark,borderRadius:8,padding:"4px 10px",cursor:"pointer",fontSize:12}}>Edit</button>
                  <button onClick={()=>delDeposit(c.id,dep.id)} style={{background:"#FFF0F0",border:`1px solid ${B.red}30`,color:B.red,borderRadius:8,padding:"4px 10px",cursor:"pointer",fontSize:12}}>Del</button>
                </div>
              </div>
            </div>

            {/* Plan numbers */}
            <div style={{background:isGold?"#FFFBF0":"#F9FAFB",borderRadius:12,padding:"13px",marginBottom:12,border:`1px solid ${isGold?"#F59E0B30":"#E5E7EB"}`}}>
              <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10}}>
                {[
                  {l:"MONTHLY HARVEST",v:fmt(mh),  c:isGold?B.gold:B.green},
                  {l:"NEXT HARVEST",   v:canW?"—":fmtDate(nextHv), c:B.dark},
                  {l:"TOTAL HARVEST",  v:fmt(totalHarvestAtEnd(dep)), c:B.green},
                  {l:"PAID SO FAR",    v:fmt(paid), c:B.blue},
                  {l:"MONTHS",         v:`${mp}/${totalM}`, c:B.dark},
                  {l:canW?"WITHDRAW NOW":"DAYS LEFT", v:canW?"READY":Math.max(0,dLeft)+"d", c:canW?B.red:dLeft<=30?B.gold:B.muted},
                ].map(s=><div key={s.l}>
                  <div style={{color:B.muted,fontSize:10,letterSpacing:1,marginBottom:3}}>{s.l}</div>
                  <div style={{color:s.c,fontSize:14,fontWeight:700}}>{s.v}</div>
                </div>)}
              </div>
            </div>

            {/* Progress */}
            <div style={{height:7,borderRadius:7,background:"#F0F0F0",overflow:"hidden"}}>
              <div style={{height:"100%",width:`${prog}%`,borderRadius:7,background:prog>=100?`linear-gradient(90deg,${B.red},${B.redD})`:`linear-gradient(90deg,${isGold?B.gold:B.green},${isGold?B.goldL:B.greenL})`}}/>
            </div>
            <div style={{display:"flex",justifyContent:"space-between",marginTop:4}}>
              <span style={{color:B.muted,fontSize:10}}>{fmtDate(dep.depositDate)}</span>
              <span style={{color:isGold?B.gold:B.green,fontSize:11,fontWeight:700}}>{Math.round(prog)}%</span>
              <span style={{color:B.muted,fontSize:10}}>{fmtDate(dep.harvestDate)}</span>
            </div>
          </div>;
        })
      }
    </div>;
  }

  function Toast(){
    if(!toast)return null;
    const col={success:{bg:"#F0FFF4",b:B.green,t:B.green},error:{bg:"#FFF0F0",b:B.red,t:B.red},info:{bg:"#EFF6FF",b:B.blue,t:B.blue}};
    const c=col[toast.type]||col.success;
    return <div style={{position:"fixed",bottom:28,left:"50%",transform:"translateX(-50%)",background:c.bg,border:`1.5px solid ${c.b}40`,color:c.t,padding:"12px 24px",borderRadius:14,fontSize:14,fontWeight:600,zIndex:9999,maxWidth:520,textAlign:"center",boxShadow:"0 6px 30px rgba(0,0,0,0.12)",fontFamily:"'Segoe UI',sans-serif"}}>{toast.msg}</div>;
  }

  if(loading)return <div style={{minHeight:"100vh",background:B.bg,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Segoe UI',sans-serif"}}><div style={{textAlign:"center"}}><div style={{display:"flex",justifyContent:"center",marginBottom:14}}><AMCLogo height={44}/></div><div style={{color:B.muted,letterSpacing:2,fontSize:13}}>LOADING…</div></div></div>;

  // ── LOGIN ─────────────────────────────────────────────────────────────────
  if(view==="login") return(
    <div style={{minHeight:"100vh",background:B.bg,display:"flex",fontFamily:"'Segoe UI',sans-serif"}}>
      <style>{`input:focus,select:focus{border-color:${B.red}!important;box-shadow:0 0 0 3px ${B.red}15!important;outline:none!important;}`}</style>

      {/* Left branding panel */}
      <div style={{flex:"0 0 42%",background:`linear-gradient(145deg,${B.redD},${B.red})`,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:50,position:"relative",overflow:"hidden"}}>
        <div style={{position:"absolute",top:-60,right:-60,width:250,height:250,borderRadius:"50%",background:"rgba(201,160,32,0.12)"}}/>
        <div style={{position:"absolute",bottom:-40,left:-40,width:180,height:180,borderRadius:"50%",background:"rgba(58,125,68,0.15)"}}/>
        <div style={{position:"relative",zIndex:1,textAlign:"center"}}>
          <div style={{display:"flex",justifyContent:"center",marginBottom:28}}><AMCLogo height={56}/></div>
          <div style={{borderTop:"1px solid rgba(255,255,255,0.2)",paddingTop:22}}>
            <div style={{color:"rgba(255,255,255,0.5)",fontSize:11,letterSpacing:1,marginBottom:12}}>INVESTMENT PLANS</div>
            {[{l:"🥈 Silver 1Y",r:"40%/yr"},{l:"🥈 Silver 2Y",r:"42%/yr"},{l:"🥇 Gold 3Y",r:"45%/yr"},{l:"🥇 Gold 5Y",r:"45%/yr"}].map(item=>(
              <div key={item.l} style={{display:"flex",justifyContent:"space-between",padding:"7px 14px",background:"rgba(255,255,255,0.08)",borderRadius:8,marginBottom:6,fontSize:13}}>
                <span style={{color:"rgba(255,255,255,0.8)",fontWeight:600}}>{item.l}</span>
                <span style={{color:B.goldL,fontWeight:700}}>{item.r}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Right login panel */}
      <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",padding:50}}>
        <div style={{width:"100%",maxWidth:420}}>
          <div style={{marginBottom:28}}>
            <h1 style={{color:B.dark,fontSize:28,fontWeight:800,margin:"0 0 6px"}}>Staff Login</h1>
            <p style={{color:B.muted,fontSize:14,margin:0}}>Select your name and enter your PIN</p>
          </div>

          <div style={{background:B.card,borderRadius:20,padding:"30px 26px",boxShadow:"0 4px 30px rgba(0,0,0,0.1)",border:`1px solid ${B.border}`}}>

            {/* Staff name dropdown - loads from shared storage */}
            <div style={{marginBottom:20}}>
              <label style={{color:B.muted,fontSize:12,fontWeight:700,display:"block",marginBottom:8,letterSpacing:1}}>SELECT YOUR NAME</label>
              <select value={selectedStaffId}
                onChange={e=>{ setSelectedStaffId(e.target.value); setPinErr(""); setTimeout(()=>document.getElementById("amc-pin-input")?.focus(),50); }}
                style={{...inpStyle,fontSize:15,padding:"13px 14px",cursor:"pointer"}}>
                <option value="">-- Select your name --</option>
                {/* Show fresh staff list fetched from shared storage */}
                {loginStaffList.map(s=>(
                  <option key={s.id||s.name} value={s.name}>{s.name} ({s.role})</option>
                ))}
              </select>
            </div>

            {/* PIN input */}
            <div style={{marginBottom:14}}>
              <label style={{color:B.muted,fontSize:12,fontWeight:700,display:"block",marginBottom:8,letterSpacing:1}}>YOUR PIN</label>
              <input id="amc-pin-input" type="password" placeholder="••••" value={pin}
                onChange={e=>setPin(e.target.value)}
                onKeyDown={e=>e.key==="Enter"&&handleStaffLogin()}
                style={{...inpStyle,fontSize:28,letterSpacing:14,textAlign:"center",padding:"15px",border:`2px solid ${B.border}`}}/>
            </div>

            {pinErr&&<div style={{background:"#FFF0F0",border:`1.5px solid ${B.red}30`,borderRadius:10,padding:"10px",marginBottom:14,color:B.red,fontSize:13,fontWeight:600}}>⚠ {pinErr}</div>}

            <button onClick={handleStaffLogin} style={{width:"100%",padding:"13px",...btnP,borderRadius:12,fontSize:16}}>
              Sign In
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  // ── PORTAL ────────────────────────────────────────────────────────────────

  return(
    <div style={{minHeight:"100vh",background:B.bg,fontFamily:"'Segoe UI',sans-serif",display:"flex"}}>
      <style>{`input:focus,select:focus{border-color:${B.red}!important;box-shadow:0 0 0 3px ${B.red}12!important;outline:none!important;}`}</style>

      {/* Sidebar */}
      <div style={{width:230,background:B.sidebar,display:"flex",flexDirection:"column",flexShrink:0}}>
        <div style={{padding:"20px 20px 14px",borderBottom:"1px solid rgba(255,255,255,0.06)"}}>
          <AMCLogo height={26}/>
          {/* Logged in staff */}
          <div style={{marginTop:14,padding:"10px 12px",background:"rgba(255,255,255,0.06)",borderRadius:10,display:"flex",alignItems:"center",gap:10}}>
            <div style={{width:32,height:32,borderRadius:"50%",background:`linear-gradient(135deg,${B.red},${B.redD})`,display:"flex",alignItems:"center",justifyContent:"center",color:B.white,fontWeight:800,fontSize:14,flexShrink:0}}>
              {loggedInStaff?.name[0]?.toUpperCase()}
            </div>
            <div>
              <div style={{color:B.white,fontWeight:700,fontSize:13}}>{loggedInStaff?.name}</div>
              <div style={{color:"rgba(255,255,255,0.4)",fontSize:10,textTransform:"uppercase",letterSpacing:0.5}}>{loggedInStaff?.role}</div>
            </div>
          </div>
        </div>
        <nav style={{flex:1,padding:"14px 10px"}}>
          {[
            {id:"dashboard",icon:"📊",label:"Dashboard"},
            {id:"customers",icon:"👥",label:"Customers"},
            {id:"alerts",   icon:"🔔",label:"Alerts",badge:pendingAlerts.length},
            ...(isAdmin?[{id:"staff",icon:"👤",label:"Staff Members"}]:[]),
            {id:"admin",    icon:"⚙️",label:"Admin"},
          ].map(item=>(
            <button key={item.id} onClick={()=>{setTab(item.id);setSelected(null);setSearchQ("");}}
              style={{width:"100%",textAlign:"left",background:tab===item.id?`${B.red}22`:"transparent",border:"none",borderLeft:tab===item.id?`3px solid ${B.red}`:"3px solid transparent",color:tab===item.id?B.white:"rgba(255,255,255,0.5)",padding:"11px 14px",cursor:"pointer",fontSize:14,borderRadius:"0 10px 10px 0",marginBottom:4,fontFamily:"inherit",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <span>{item.icon} {item.label}</span>
              {item.badge>0&&<span style={{background:B.red,color:B.white,borderRadius:20,padding:"1px 8px",fontSize:11,fontWeight:700}}>{item.badge}</span>}
            </button>
          ))}
        </nav>
        <div style={{padding:"14px 12px",borderTop:"1px solid rgba(255,255,255,0.06)"}}>
          {smsConfig.configured&&<div style={{background:`${B.green}20`,border:`1px solid ${B.green}30`,borderRadius:10,padding:"7px 12px",marginBottom:10,fontSize:11,color:B.green,fontWeight:600}}>📱 Dialog SMS Active</div>}
          <button onClick={handleLogout} style={{width:"100%",background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",color:"rgba(255,255,255,0.6)",borderRadius:10,padding:"9px",cursor:"pointer",fontSize:13,fontFamily:"inherit"}}>↗ Logout</button>
        </div>
      </div>

      {/* Main */}
      <div style={{flex:1,overflowY:"auto",padding:"28px 30px"}}>

        {/* ── DASHBOARD ── */}
        {tab==="dashboard"&&<div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24}}>
            <div>
              <h2 style={{color:B.dark,margin:"0 0 4px",fontSize:24,fontWeight:800}}>Dashboard</h2>
              <p style={{color:B.muted,margin:0,fontSize:14}}>Agro Multi Cultivation (Pvt) Ltd</p>
            </div>
            <AMCLogo height={28}/>
          </div>

          {/* KPI cards */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14,marginBottom:24}}>
            {[
              {l:"CUSTOMERS",           v:customerList.length,                                                       c:B.red,   icon:"👥", sub:`${customerList.filter(c=>c.tempPassword).length} with temp password`},
              {l:"TOTAL DEPOSITED",     v:fmt(totalFunds),                                                           c:B.green, icon:"💰"},
              {l:"MONTHLY HARVEST OUT", v:fmt(totalMonthlyOut),                                                      c:B.gold,  icon:"📆", sub:"paid each month"},
              {l:"TOTAL HARVEST PAID",  v:fmt(totalHarvestPaidOut),                                                  c:B.blue,  icon:"✅", sub:"since inception"},
              {l:"PLAN ENDED",          v:allDeps.filter(d=>depositStatus(d)==="Plan Ended").length,                 c:B.red,   icon:"⛔", sub:"withdrawal pending"},
              {l:"PENDING ALERTS",      v:pendingAlerts.length,                                                      c:"#7B68EE",icon:"🔔"},
            ].map(s=>(
              <div key={s.l} style={{background:B.card,border:`1px solid ${B.border}`,borderRadius:16,padding:"18px",boxShadow:"0 2px 10px rgba(0,0,0,0.05)"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                  <div>
                    <div style={{color:B.muted,fontSize:10,letterSpacing:1.5,marginBottom:7,fontWeight:600}}>{s.l}</div>
                    <div style={{color:s.c,fontSize:22,fontWeight:800}}>{s.v}</div>
                    {s.sub&&<div style={{color:B.muted,fontSize:11,marginTop:3}}>{s.sub}</div>}
                  </div>
                  <div style={{fontSize:20,opacity:0.6}}>{s.icon}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Plans breakdown */}
          <div style={{background:B.card,border:`1px solid ${B.border}`,borderRadius:16,padding:22,marginBottom:20,boxShadow:"0 2px 10px rgba(0,0,0,0.05)"}}>
            <div style={{color:B.dark,fontWeight:700,fontSize:15,marginBottom:14}}>Plans Overview</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12}}>
              {Object.entries(PLANS).map(([key,plan])=>{
                const deps=allDeps.filter(d=>d.planKey===key);
                const tot=deps.reduce((a,d)=>a+d.amount,0);
                const mthOut=deps.reduce((a,d)=>a+monthlyHarvest(d),0);
                const isGold=key.startsWith("Gold");
                return <div key={key} style={{background:isGold?"#FFFBF0":"#F9FAFB",borderRadius:12,padding:"14px",border:`1px solid ${isGold?"#F59E0B30":"#E5E7EB"}`}}>
                  <div style={{fontSize:18,marginBottom:6}}>{isGold?"🥇":"🥈"}</div>
                  <div style={{color:B.dark,fontWeight:700,fontSize:13}}>{plan.label}</div>
                  <div style={{color:B.muted,fontSize:11,marginBottom:8}}>{plan.years}Y · {plan.ratePerYear}%/yr · {(plan.ratePerYear/12).toFixed(2)}%/mo</div>
                  <div style={{color:isGold?B.gold:B.green,fontWeight:800,fontSize:17}}>{deps.length}</div>
                  <div style={{color:B.muted,fontSize:11}}>plans · {fmt(tot)}</div>
                  <div style={{color:B.blue,fontSize:11,marginTop:3}}>{fmt(mthOut)}/mo</div>
                </div>;
              })}
            </div>
          </div>

          {/* Customers list */}
          <div style={{color:B.muted,fontWeight:700,fontSize:12,letterSpacing:1.5,marginBottom:12}}>CUSTOMERS</div>
          {customerList.map(c=>{
            const statuses=c.deposits.map(depositStatus);
            const top=statuses.includes("Plan Ended")?"Plan Ended":statuses.includes("Maturing Soon")?"Maturing Soon":"Active";
            const totalDep=c.deposits.reduce((a,d)=>a+d.amount,0);
            const totalHarvPaid=c.deposits.reduce((a,d)=>a+harvestPaidSoFar(d),0);
            return <div key={c.id} onClick={()=>{setTab("customers");setSelected(c);}}
              style={{background:B.card,border:`1.5px solid ${B.border}`,borderRadius:14,padding:"14px 20px",marginBottom:10,display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer",transition:"all 0.15s"}}
              onMouseEnter={e=>{e.currentTarget.style.borderColor=B.red;e.currentTarget.style.boxShadow=`0 4px 18px ${B.red}15`;}}
              onMouseLeave={e=>{e.currentTarget.style.borderColor=B.border;e.currentTarget.style.boxShadow="none";}}>
              <div style={{display:"flex",alignItems:"center",gap:12}}>
                <div style={{width:40,height:40,borderRadius:12,background:`linear-gradient(135deg,${B.red},${B.redD})`,display:"flex",alignItems:"center",justifyContent:"center",color:B.white,fontWeight:800,fontSize:16,flexShrink:0}}>{c.name[0]}</div>
                <div>
                  <div style={{color:B.dark,fontWeight:700,fontSize:15,display:"flex",alignItems:"center",gap:6}}>
                    {c.name}
                    {c.tempPassword&&<span style={{background:"#FFF3CD",color:"#856404",fontSize:10,fontWeight:700,borderRadius:4,padding:"1px 6px",border:"1px solid #FFECB5"}}>TEMP PW</span>}
                  </div>
                  <div style={{color:B.muted,fontSize:12,marginTop:1}}>{c.id} · {c.email} · {c.deposits.length} plan{c.deposits.length!==1?"s":""}</div>
                </div>
              </div>
              <div style={{textAlign:"right",display:"flex",flexDirection:"column",alignItems:"flex-end",gap:5}}>
                <div style={{color:B.green,fontWeight:800,fontSize:15}}>{fmt(totalDep)}</div>
                <div style={{color:B.blue,fontSize:11}}>harvest paid: {fmt(totalHarvPaid)}</div>
                <StatusBadge status={top}/>
              </div>
            </div>;
          })}
        </div>}

        {/* ── CUSTOMERS ── */}
        {tab==="customers"&&!selected&&<div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
            <div><h2 style={{color:B.dark,margin:"0 0 4px",fontSize:24,fontWeight:800}}>Customers</h2><p style={{color:B.muted,margin:0,fontSize:14}}>{customerList.length} accounts</p></div>
            <button onClick={()=>{setForm({id:nextId(customers),name:"",phone:"",email:""});setModal("addCustomer");}} style={btnP}>+ New Customer</button>
          </div>
          <input type="text" placeholder="🔍  Search name, ID, email, or phone…" value={searchQ} onChange={e=>setSearchQ(e.target.value)} style={{...inpStyle,padding:"12px 16px",borderRadius:12,marginBottom:16}}/>
          {filteredCustomers.length===0
            ?<div style={{color:B.muted,textAlign:"center",padding:60,background:B.card,borderRadius:16,border:`1px solid ${B.border}`}}>No customers found.</div>
            :filteredCustomers.map(c=>{
              const statuses=c.deposits.map(depositStatus);
              const top=statuses.includes("Plan Ended")?"Plan Ended":statuses.includes("Maturing Soon")?"Maturing Soon":"Active";
              return <div key={c.id} onClick={()=>setSelected(c)}
                style={{background:B.card,border:`1.5px solid ${B.border}`,borderRadius:14,padding:"16px 20px",marginBottom:10,display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer",transition:"all 0.15s"}}
                onMouseEnter={e=>{e.currentTarget.style.borderColor=B.red;e.currentTarget.style.boxShadow=`0 4px 18px ${B.red}12`;}}
                onMouseLeave={e=>{e.currentTarget.style.borderColor=B.border;e.currentTarget.style.boxShadow="none";}}>
                <div style={{display:"flex",alignItems:"center",gap:14}}>
                  <div style={{width:44,height:44,borderRadius:14,background:`linear-gradient(135deg,${B.red},${B.redD})`,display:"flex",alignItems:"center",justifyContent:"center",color:B.white,fontWeight:800,fontSize:18,flexShrink:0}}>{c.name[0]}</div>
                  <div>
                    <div style={{color:B.dark,fontWeight:700,fontSize:15,display:"flex",alignItems:"center",gap:6}}>
                      {c.name}
                      {c.tempPassword&&<span style={{background:"#FFF3CD",color:"#856404",fontSize:10,fontWeight:700,borderRadius:4,padding:"1px 6px",border:"1px solid #FFECB5"}}>TEMP PW</span>}
                    </div>
                    <div style={{color:B.muted,fontSize:12,marginTop:2}}>{c.id} · {c.email}</div>
                  </div>
                </div>
                <div style={{textAlign:"right",display:"flex",flexDirection:"column",alignItems:"flex-end",gap:6}}>
                  <div style={{color:B.green,fontWeight:800,fontSize:16}}>{fmt(c.deposits.reduce((a,d)=>a+d.amount,0))}</div>
                  <StatusBadge status={top}/>
                </div>
              </div>;
            })
          }
        </div>}

        {tab==="customers"&&selected&&<div>
          <button onClick={()=>setSelected(null)} style={{background:"#F5F5F5",border:`1.5px solid ${B.border}`,color:B.muted,padding:"8px 14px",borderRadius:10,cursor:"pointer",fontSize:13,marginBottom:20,fontFamily:"inherit"}}>← All Customers</button>
          <CustomerDetail c={selected}/>
        </div>}

        {/* ── ALERTS ── */}
        {tab==="alerts"&&<div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
            <div><h2 style={{color:B.dark,margin:"0 0 4px",fontSize:24,fontWeight:800}}>Plan Alerts</h2><p style={{color:B.muted,margin:0,fontSize:14}}>{pendingAlerts.length} pending SMS</p></div>
          </div>
          <div style={{background:smsConfig.configured?`${B.green}10`:`${B.gold}10`,border:`1.5px solid ${smsConfig.configured?B.green:B.gold}30`,borderRadius:12,padding:"12px 18px",marginBottom:20,color:smsConfig.configured?B.green:B.gold,fontSize:14,fontWeight:600}}>
            📱 {smsConfig.configured?`Dialog SMS active · Sender: ${smsConfig.senderId}`:"Go to Admin to configure Dialog SMS"}
          </div>
          {alerts.length===0
            ?<div style={{color:B.muted,textAlign:"center",padding:60,background:B.card,borderRadius:16,border:`1px solid ${B.border}`}}>No alerts. All plans on track! 🌿</div>
            :alerts.map(a=>{
              const plan=PLANS[a.planKey];
              const mh=a.amount&&a.planKey?monthlyHarvest({amount:a.amount,planKey:a.planKey}):0;
              return <div key={a.id} style={{background:B.card,border:`1.5px solid ${a.type==="ended"?B.red:a.type==="today"?B.gold:B.border}30`,borderRadius:16,padding:20,marginBottom:12,boxShadow:"0 2px 10px rgba(0,0,0,0.05)"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}>
                  <div>
                    <div style={{color:B.dark,fontWeight:700,fontSize:16}}>{a.customerName} <span style={{color:B.muted,fontSize:13,fontWeight:400}}>({a.customerId})</span></div>
                    <div style={{color:B.muted,fontSize:12,marginTop:2}}>📱 {a.phone}</div>
                    <div style={{marginTop:6}}><PlanBadge planKey={a.planKey}/></div>
                    <div style={{color:B.dark,fontWeight:700,fontSize:15,marginTop:8}}>{fmt(a.amount)}</div>
                    <div style={{color:B.muted,fontSize:12}}>Monthly harvest: {fmt(mh)} · Plan ends: {fmtDate(a.harvestDate)}</div>
                    <div style={{color:a.type==="ended"?B.red:a.type==="today"?B.gold:B.blue,fontSize:14,marginTop:6,fontWeight:600}}>
                      {a.type==="ended"?`⛔ Plan ended ${Math.abs(a.daysLeft)}d ago — withdrawal available`:a.type==="today"?"⏳ Plan ends today!":`📅 Plan ends in ${a.daysLeft} days`}
                    </div>
                    {a.sentSms&&a.smsSentAt&&<div style={{color:B.green,fontSize:12,marginTop:4,fontWeight:600}}>✓ SMS sent {new Date(a.smsSentAt).toLocaleString()}</div>}
                  </div>
                  <button onClick={()=>setAlerts(p=>p.filter(x=>x.id!==a.id))} style={{background:"#F5F5F5",border:"none",color:B.muted,borderRadius:"50%",width:30,height:30,cursor:"pointer",fontSize:15,display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
                </div>
                <button onClick={()=>sendSMS(a)} disabled={a.sentSms||smsSending[a.id]}
                  style={{padding:"9px 18px",background:a.sentSms?"#F0FFF4":smsConfig.configured?`linear-gradient(135deg,${B.green},${B.greenL})`:"#F5F5F5",border:`1.5px solid ${a.sentSms?B.green:smsConfig.configured?B.green:B.border}`,color:a.sentSms?B.green:smsConfig.configured?B.white:B.muted,borderRadius:10,cursor:a.sentSms?"default":"pointer",fontSize:13,fontWeight:700,fontFamily:"inherit"}}>
                  {smsSending[a.id]?"Sending…":a.sentSms?"📱 SMS Sent ✓":smsConfig.configured?"📱 Send Real SMS":"📱 Setup SMS First"}
                </button>
              </div>;
            })
          }
        </div>}

        {/* ── STAFF MEMBERS (admin only) ── */}
        {tab==="staff"&&isAdmin&&<div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24}}>
            <div>
              <h2 style={{color:B.dark,margin:"0 0 4px",fontSize:24,fontWeight:800}}>Staff Members</h2>
              <p style={{color:B.muted,margin:0,fontSize:14}}>{(staffMembers||[]).length} members · Only admins can manage staff</p>
            </div>
            <button onClick={()=>{ const newId="S"+String(Date.now()).slice(-4); setForm({id:newId,name:"",role:"staff",pin:""}); setModal("addStaff"); }} style={btnP}>+ Add Staff</button>
          </div>

          {(staffMembers||[]).map(s=>(
            <div key={s.id} style={{background:B.card,border:`1.5px solid ${B.border}`,borderRadius:16,padding:"18px 22px",marginBottom:12,display:"flex",justifyContent:"space-between",alignItems:"center",boxShadow:"0 2px 10px rgba(0,0,0,0.05)"}}>
              <div style={{display:"flex",alignItems:"center",gap:14}}>
                <div style={{width:46,height:46,borderRadius:"50%",background:`linear-gradient(135deg,${B.red},${B.redD})`,display:"flex",alignItems:"center",justifyContent:"center",color:B.white,fontWeight:800,fontSize:18,flexShrink:0}}>
                  {s.name[0]?.toUpperCase()}
                </div>
                <div>
                  <div style={{color:B.dark,fontWeight:700,fontSize:16,display:"flex",alignItems:"center",gap:8}}>
                    {s.name}
                    {s.role==="admin"&&<span style={{background:`${B.red}15`,color:B.red,border:`1px solid ${B.red}30`,borderRadius:20,padding:"2px 10px",fontSize:11,fontWeight:700}}>ADMIN</span>}
                  </div>
                  <div style={{color:B.muted,fontSize:13,marginTop:2}}>ID: {s.id} · PIN: {"•".repeat(s.pin.length)}</div>
                </div>
              </div>
              <div style={{display:"flex",gap:8}}>
                <button onClick={()=>setForm({...s})||setModal("editStaff")} style={{background:"#F5F5F5",border:`1px solid ${B.border}`,color:B.dark,borderRadius:8,padding:"7px 14px",cursor:"pointer",fontSize:13,fontFamily:"inherit"}}>Edit</button>
                {s.id!=="S001"&&<button onClick={()=>{if(!window.confirm(`Delete ${s.name}?`))return; setStaffMembers(p=>p.filter(x=>x.id!==s.id)); showToast("Staff member deleted.");}} style={{background:"#FFF0F0",border:`1px solid ${B.red}30`,color:B.red,borderRadius:8,padding:"7px 14px",cursor:"pointer",fontSize:13,fontFamily:"inherit"}}>Delete</button>}
              </div>
            </div>
          ))}

          <div style={{background:`${B.blue}08`,border:`1px solid ${B.blue}20`,borderRadius:14,padding:"14px 18px",marginTop:8}}>
            <div style={{color:B.blue,fontWeight:600,fontSize:13}}>💡 Tips</div>
            <div style={{color:B.muted,fontSize:13,marginTop:6,lineHeight:1.7}}>
              • <strong>Admin</strong> role — can manage staff members, access all settings<br/>
              • <strong>Staff</strong> role — can manage customers, plans, alerts but cannot manage staff<br/>
              • Use a 4–6 digit PIN for each staff member<br/>
              • The first Admin account (S001) cannot be deleted
            </div>
          </div>
        </div>}

        {/* ── ADMIN ── */}
        {tab==="admin"&&<div>
          <h2 style={{color:B.dark,margin:"0 0 24px",fontSize:24,fontWeight:800}}>Admin</h2>

          {/* Plans ref */}
          <div style={{background:B.card,border:`1px solid ${B.border}`,borderRadius:16,padding:22,marginBottom:22,boxShadow:"0 2px 10px rgba(0,0,0,0.05)"}}>
            <div style={{color:B.dark,fontWeight:700,fontSize:15,marginBottom:14}}>📋 AMC Investment Plans</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:12}}>
              {[
                {key:"Silver-1Y",icon:"🥈",r:"40%/yr",m:"3.33%/mo",t:"40% total",lock:"1 year"},
                {key:"Silver-2Y",icon:"🥈",r:"42%/yr",m:"3.50%/mo",t:"84% total",lock:"2 years"},
                {key:"Gold-3Y",  icon:"🥇",r:"45%/yr",m:"3.75%/mo",t:"135% total",lock:"3 years"},
                {key:"Gold-5Y",  icon:"🥇",r:"45%/yr",m:"3.75%/mo",t:"225% total",lock:"5 years"},
              ].map(item=><div key={item.key} style={{background:item.key.startsWith("Gold")?"#FFFBF0":"#F9FAFB",borderRadius:12,padding:"16px",border:`1px solid ${item.key.startsWith("Gold")?"#F59E0B30":"#E5E7EB"}`}}>
                <div style={{fontSize:22,marginBottom:8}}>{item.icon} {PLANS[item.key].label} · {PLANS[item.key].years}Y</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,fontSize:13}}>
                  <div><span style={{color:B.muted}}>Rate: </span><strong style={{color:B.dark}}>{item.r}</strong></div>
                  <div><span style={{color:B.muted}}>Monthly: </span><strong style={{color:B.green}}>{item.m}</strong></div>
                  <div><span style={{color:B.muted}}>Total: </span><strong style={{color:B.blue}}>{item.t}</strong></div>
                  <div><span style={{color:B.muted}}>Lock: </span><strong style={{color:B.red}}>{item.lock}</strong></div>
                </div>
              </div>)}
            </div>
            <div style={{marginTop:14,padding:"12px 14px",background:`${B.green}08`,borderRadius:10,border:`1px solid ${B.green}20`}}>
              <div style={{color:B.green,fontSize:12,fontWeight:600}}>💡 Monthly Harvest = Deposit × (Rate%/yr ÷ 12) · Transferred on same date each month · Deposit principal locked until plan end date</div>
            </div>
          </div>

          {/* SMS Config */}
          <div style={{background:smsConfig.configured?`${B.green}08`:B.card,border:`1.5px solid ${smsConfig.configured?B.green:B.border}40`,borderRadius:20,padding:22,marginBottom:22,boxShadow:"0 2px 12px rgba(0,0,0,0.06)"}}>
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:4}}>
              <h3 style={{color:smsConfig.configured?B.green:B.dark,margin:0,fontSize:17,fontWeight:800}}>📱 Dialog eSMS</h3>
              {smsConfig.configured&&<span style={{background:`${B.green}15`,color:B.green,borderRadius:20,padding:"3px 12px",fontSize:12,fontWeight:700}}>ACTIVE</span>}
            </div>
            <p style={{color:B.muted,fontSize:13,margin:"0 0 18px",lineHeight:1.7}}>
              Sends SMS to Dialog, Mobitel, Hutch & Airtel. Login at <a href="https://esms.dialog.lk" target="_blank" rel="noopener noreferrer" style={{color:B.red,fontWeight:600}}>esms.dialog.lk</a> to get your API token.
            </p>
            <div style={{display:"grid",gridTemplateColumns:"2fr 1fr",gap:12,marginBottom:16}}>
              <div>
                <label style={{color:B.muted,fontSize:12,fontWeight:600,display:"block",marginBottom:5}}>TEXT.LK API TOKEN</label>
                <input type="text" value={smsConfig.username} onChange={e=>setSmsConfig(p=>({...p,username:e.target.value}))} placeholder="info@agromulticultivation.com" style={{...inpStyle,marginBottom:8}}/>
                <input type="password" value={smsConfig.apiToken} onChange={e=>setSmsConfig(p=>({...p,apiToken:e.target.value}))} placeholder="API Password" style={inpStyle}/>
              </div>
              <div>
                <label style={{color:B.muted,fontSize:12,fontWeight:600,display:"block",marginBottom:5}}>SENDER ID</label>
                <input type="text" value={smsConfig.senderId} onChange={e=>setSmsConfig(p=>({...p,senderId:e.target.value}))} placeholder="AMC" style={inpStyle}/>
              </div>
            </div>
            <div style={{display:"flex",gap:10}}>
              <button onClick={()=>{if(!smsConfig.username||!smsConfig.apiToken||!smsConfig.senderId)return showToast("Enter username, API password and Sender ID.","error");setSmsConfig(p=>({...p,configured:true}));showToast("✅ SMS activated!");}} style={btnP}>Save & Activate</button>
              {smsConfig.configured&&<button onClick={()=>{setSmsConfig({username:"",apiToken:"",senderId:"AMC",configured:false});showToast("Disconnected.","info");}} style={{padding:"9px 20px",background:"transparent",border:`1.5px solid ${B.red}40`,color:B.red,borderRadius:10,cursor:"pointer",fontSize:14,fontFamily:"inherit"}}>Disconnect</button>}
            </div>
          </div>

          {/* Tools */}
          <div style={{color:B.muted,fontWeight:700,fontSize:12,letterSpacing:1.5,marginBottom:14}}>DATA TOOLS</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:13}}>
            {[
              {l:"Export Customers",c:B.green,icon:"📥",a:()=>{ exportCustomersExcel(customers,PLANS); showToast("✅ Excel file downloaded!"); }},
              {l:"Export Alerts",   c:B.blue, icon:"📋",a:()=>{ exportAlertsExcel(alerts); showToast("✅ Excel file downloaded!"); }},
              {l:"Clear Alerts",   c:B.gold, icon:"🗑", a:()=>{if(!window.confirm("Clear all alerts?")){ return; } setAlerts([]);showToast("Cleared."); }},
            ].map(item=><div key={item.l} style={{background:B.card,border:`1.5px solid ${B.border}`,borderRadius:14,padding:18,boxShadow:"0 2px 8px rgba(0,0,0,0.05)"}}>
              <div style={{fontSize:22,marginBottom:8}}>{item.icon}</div>
              <div style={{color:item.c,fontWeight:700,fontSize:14,marginBottom:12}}>{item.l}</div>
              <button onClick={item.a} style={{background:`${item.c}12`,border:`1.5px solid ${item.c}30`,color:item.c,padding:"8px 16px",borderRadius:9,cursor:"pointer",fontSize:13,fontWeight:600,fontFamily:"inherit"}}>Run</button>
            </div>)}
          </div>
        </div>}
      </div>

      {/* MODALS */}
      {modal==="addCustomer"&&<Modal title="Add New Customer" onClose={()=>setModal(null)}>
        <Field label="ACCOUNT ID" name="id" value={form.id||""} onChange={(n,v)=>setForm(p=>({...p,[n]:v}))} placeholder="AMC-005"/>
        <Field label="FULL NAME"  name="name" value={form.name||""} onChange={(n,v)=>setForm(p=>({...p,[n]:v}))}/>
        <Field label="EMAIL ADDRESS" name="email" value={form.email||""} onChange={(n,v)=>setForm(p=>({...p,[n]:v}))} placeholder="customer@email.com"/>
        <Field label="PHONE (94XXXXXXXXX)" name="phone" value={form.phone||""} onChange={(n,v)=>setForm(p=>({...p,[n]:v}))} placeholder="94771234567"/>
        <div style={{background:`${B.gold}10`,border:`1.5px solid ${B.gold}30`,borderRadius:12,padding:"14px 16px",marginBottom:16}}>
          <div style={{color:B.gold,fontWeight:700,fontSize:13,marginBottom:4}}>🔑 Auto Temporary Password</div>
          <div style={{color:B.muted,fontSize:12}}>A temporary password will be auto-generated. Customer must change it on first login.</div>
        </div>
        <button onClick={()=>{
          if(!form.id||!form.name||!form.email)return showToast("ID, Name and Email required.","error");
          const tempPw=generateTempPw();
          saveCustomer({...form,deposits:[],password:tempPw,tempPassword:true});
          setCreatedPw({name:form.name,email:form.email,pw:tempPw,id:form.id});
          setModal(null);
          // Send welcome email
          sendEmailAPI("new_account",form.email,form.name,form.id,tempPw).then(r=>{
            if(r.success) showToast(`✅ Customer created! Welcome email sent to ${form.email}`);
            else showToast(`✅ Customer created! (Email failed: ${r.message})`, "info");
          });
          // Send welcome SMS with login credentials
          if(smsConfig.configured && form.phone){
            (async()=>{
              try{
                const phone=form.phone.replace(/^0/,"94").replace(/[^0-9]/g,"");
                const msg=`Welcome to AMC - Agro Multi Cultivation!\nAccount ID: ${form.id}\nPassword: ${tempPw}\nLogin: agromulticultivation.com\nHotline: +94 117 297 555`;
                const loginRes=await fetch("https://esms.dialog.lk/api/v2/user/login",{
                  method:"POST",
                  headers:{"Content-Type":"application/json"},
                  body:JSON.stringify({username:smsConfig.username,password:smsConfig.apiToken})
                });
                const loginData=await loginRes.json();
                if(!loginData.token) throw new Error("Login failed");
                await fetch("https://esms.dialog.lk/api/v2/send/sms",{
                  method:"POST",
                  headers:{"Content-Type":"application/json",Authorization:`Bearer ${loginData.token}`},
                  body:JSON.stringify({
                    msisdn:[{mobile:phone}],
                    sourceAddress:smsConfig.senderId,
                    message:msg,
                    transaction_id:Date.now(),
                    payment_method:0
                  })
                });
                showToast(`📱 Welcome SMS sent to ${form.phone}`);
              } catch(e){ showToast(`⚠️ SMS failed: ${e.message}`,"info"); }
            })();
          }
        }} style={{...btnP,width:"100%",padding:14,fontSize:15,borderRadius:12}}>Create Customer</button>
      </Modal>}

      {modal==="editCustomer"&&<Modal title="Edit Customer" onClose={()=>setModal(null)}>
        <Field label="FULL NAME" name="name" value={form.name||""} onChange={(n,v)=>setForm(p=>({...p,[n]:v}))}/>
        <Field label="EMAIL" name="email" value={form.email||""} onChange={(n,v)=>setForm(p=>({...p,[n]:v}))}/>
        <Field label="PHONE" name="phone" value={form.phone||""} onChange={(n,v)=>setForm(p=>({...p,[n]:v}))}/>
        <div style={{borderTop:`1px solid ${B.border}`,paddingTop:14,marginTop:4}}>
          <div style={{color:B.red,fontSize:12,fontWeight:700,marginBottom:10}}>🔑 MANUALLY CHANGE PASSWORD (optional)</div>
          <Field label="NEW PASSWORD (leave blank to keep)" name="password" type="password" value={form.password||""} onChange={(n,v)=>setForm(p=>({...p,[n]:v}))} placeholder="Leave blank to keep current"/>
        </div>
        <button onClick={()=>{
          const ex=customers[form.id];
          const newPw=form.password?{password:form.password,tempPassword:false}:{};
          const updated={...ex,name:form.name,email:form.email,phone:form.phone,...newPw};
          saveCustomer(updated); if(selected?.id===form.id)setSelected(updated);
          setModal(null); showToast("Updated!");
        }} style={{...btnP,width:"100%",padding:14,fontSize:15,borderRadius:12}}>Save Changes</button>
      </Modal>}

      {modal==="addDeposit"&&<Modal title="Add Investment Plan" onClose={()=>setModal(null)}>
        <div style={{marginBottom:15}}>
          <label style={{color:B.muted,fontSize:12,fontWeight:600,display:"block",marginBottom:5,letterSpacing:0.5}}>SELECT PLAN</label>
          <select value={form.planKey||"Silver-1Y"} onChange={e=>{const pk=e.target.value;const hd=form.depositDate?calcHarvestDate(form.depositDate,pk):"";setForm(p=>({...p,planKey:pk,harvestDate:hd}));}}
            style={{...inpStyle,cursor:"pointer"}}>
            {PLAN_OPTIONS.map(o=><option key={o.key} value={o.key}>{o.label}</option>)}
          </select>
        </div>
        <Field label="DEPOSIT AMOUNT (LKR)" name="amount" type="number" value={form.amount||""} onChange={(n,v)=>setForm(p=>({...p,[n]:v}))} placeholder="100000"/>
        <div style={{marginBottom:15}}>
          <label style={{color:B.muted,fontSize:12,fontWeight:600,display:"block",marginBottom:5}}>DEPOSIT DATE</label>
          <input type="date" value={form.depositDate||""} onChange={e=>{const dd=e.target.value;const pk=form.planKey||"Silver-1Y";setForm(p=>({...p,depositDate:dd,harvestDate:calcHarvestDate(dd,pk)}));}} style={inpStyle}/>
        </div>
        {form.depositDate&&form.planKey&&form.amount&&(()=>{
          const p=PLANS[form.planKey];const amt=parseFloat(form.amount)||0;
          const mh=amt*(p.ratePerYear/100/12);
          const tot=amt*(p.ratePerYear/100)*p.years;
          return <div style={{background:`${B.green}08`,border:`1px solid ${B.green}20`,borderRadius:12,padding:"14px",marginBottom:16}}>
            <div style={{color:B.green,fontWeight:700,fontSize:13,marginBottom:10}}>📊 Plan Preview</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,fontSize:13}}>
              <div><span style={{color:B.muted}}>Plan End: </span><strong>{fmtDate(form.harvestDate)}</strong></div>
              <div><span style={{color:B.muted}}>Monthly Harvest: </span><strong style={{color:B.gold}}>{fmt(mh)}</strong></div>
              <div><span style={{color:B.muted}}>Total Harvest: </span><strong style={{color:B.green}}>{fmt(tot)}</strong></div>
              <div><span style={{color:B.muted}}>Duration: </span><strong>{p.years} year{p.years>1?"s":""}</strong></div>
            </div>
          </div>;
        })()}
        <button onClick={()=>{
          if(!form.amount||!form.depositDate||!form.planKey)return showToast("All fields required.","error");
          const pk=form.planKey||"Silver-1Y";
          addDeposit(form.customerId,{amount:parseFloat(form.amount),depositDate:form.depositDate,planKey:pk,harvestDate:calcHarvestDate(form.depositDate,pk)});
          setModal(null);
        }} style={{...btnP,width:"100%",padding:14,fontSize:15,borderRadius:12}}>Add Investment Plan</button>
      </Modal>}

      {modal==="editDeposit"&&<Modal title="Edit Investment Plan" onClose={()=>setModal(null)}>
        <div style={{marginBottom:15}}>
          <label style={{color:B.muted,fontSize:12,fontWeight:600,display:"block",marginBottom:5}}>PLAN</label>
          <select value={form.planKey||"Silver-1Y"} onChange={e=>{const pk=e.target.value;const hd=form.depositDate?calcHarvestDate(form.depositDate,pk):"";setForm(p=>({...p,planKey:pk,harvestDate:hd}));}} style={{...inpStyle,cursor:"pointer"}}>
            {PLAN_OPTIONS.map(o=><option key={o.key} value={o.key}>{o.label}</option>)}
          </select>
        </div>
        <Field label="AMOUNT (LKR)" name="amount" type="number" value={form.amount||""} onChange={(n,v)=>setForm(p=>({...p,[n]:v}))}/>
        <div style={{marginBottom:15}}>
          <label style={{color:B.muted,fontSize:12,fontWeight:600,display:"block",marginBottom:5}}>DEPOSIT DATE</label>
          <input type="date" value={form.depositDate||""} onChange={e=>{const dd=e.target.value;setForm(p=>({...p,depositDate:dd,harvestDate:calcHarvestDate(dd,form.planKey||"Silver-1Y")}));}} style={inpStyle}/>
        </div>
        {form.amount&&form.planKey&&<div style={{background:`${B.green}08`,border:`1px solid ${B.green}20`,borderRadius:10,padding:"12px",marginBottom:14}}>
          <div style={{color:B.green,fontWeight:600,fontSize:12}}>
            Monthly Harvest: <strong>{fmt((parseFloat(form.amount)||0)*(PLANS[form.planKey]?.ratePerYear||0)/100/12)}</strong> · 
            Plan ends: <strong>{form.harvestDate?fmtDate(form.harvestDate):"—"}</strong>
          </div>
        </div>}
        <button onClick={()=>{updateDeposit(form.customerId,form.id,{amount:parseFloat(form.amount),depositDate:form.depositDate,planKey:form.planKey,harvestDate:calcHarvestDate(form.depositDate,form.planKey||"Silver-1Y")});setModal(null);}} style={{...btnP,width:"100%",padding:14,fontSize:15,borderRadius:12}}>Save Changes</button>
      </Modal>}

      {/* New customer created — show temp password */}
      {createdPw&&<Modal title="✅ Customer Created" onClose={()=>setCreatedPw(null)}>
        <div style={{textAlign:"center",padding:"10px 0"}}>
          <div style={{fontSize:48,marginBottom:14}}>🔑</div>
          <div style={{color:B.dark,fontWeight:700,fontSize:17,marginBottom:4}}>{createdPw.name}</div>
          <div style={{color:B.muted,fontSize:13,marginBottom:20}}>{createdPw.email}</div>
          <div style={{background:`${B.gold}15`,border:`1.5px solid ${B.gold}40`,borderRadius:14,padding:"18px",marginBottom:20}}>
            <div style={{color:B.muted,fontSize:12,marginBottom:8,fontWeight:600}}>TEMPORARY PASSWORD</div>
            <div style={{color:B.dark,fontSize:24,fontWeight:800,fontFamily:"monospace",letterSpacing:3}}>{createdPw.pw}</div>
            <div style={{color:B.muted,fontSize:11,marginTop:8,lineHeight:1.6}}>Share this with the customer. They will be asked to set a new password on their first login via email or Account ID.</div>
          </div>
          <div style={{background:`${B.blue}10`,border:`1px solid ${B.blue}20`,borderRadius:10,padding:"12px",marginBottom:16,textAlign:"left"}}>
            <div style={{color:B.blue,fontWeight:600,fontSize:12,marginBottom:4}}>Customer Login Info:</div>
            <div style={{color:B.dark,fontSize:13}}>Email: <strong>{createdPw.email}</strong></div>
            <div style={{color:B.dark,fontSize:13}}>Temp PW: <strong style={{fontFamily:"monospace"}}>{createdPw.pw}</strong></div>
          </div>
          <button onClick={()=>setCreatedPw(null)} style={{...btnP,width:"100%",padding:13,fontSize:15,borderRadius:12}}>Done</button>
        </div>
      </Modal>}

      {/* ADD STAFF MODAL */}
      {modal==="addStaff"&&<Modal title="Add Staff Member" onClose={()=>setModal(null)}>
        <Field label="FULL NAME" name="name" value={form.name||""} onChange={(n,v)=>setForm(p=>({...p,[n]:v}))} placeholder="e.g. Nimal Perera"/>
        <div style={{marginBottom:15}}>
          <label style={{color:B.muted,fontSize:12,fontWeight:600,display:"block",marginBottom:5,letterSpacing:0.5}}>ROLE</label>
          <select value={form.role||"staff"} onChange={e=>setForm(p=>({...p,role:e.target.value}))} style={{...inpStyle,cursor:"pointer"}}>
            <option value="staff">Staff — standard access</option>
            <option value="admin">Admin — full access including staff management</option>
          </select>
        </div>
        <Field label="PIN (4–6 digits)" name="pin" type="password" value={form.pin||""} onChange={(n,v)=>setForm(p=>({...p,[n]:v}))} placeholder="e.g. 5678"/>
        <div style={{background:`${B.gold}10`,border:`1px solid ${B.gold}30`,borderRadius:10,padding:"12px 14px",marginBottom:16}}>
          <div style={{color:B.gold,fontSize:12,fontWeight:600}}>💡 The staff member will use this PIN to log in on the login screen.</div>
        </div>
        <button onClick={()=>{
          if(!form.name||!form.pin) return showToast("Name and PIN are required.","error");
          if(form.pin.length<4) return showToast("PIN must be at least 4 digits.","error");
          setStaffMembers(p=>[...p,{id:form.id,name:form.name,role:form.role||"staff",pin:form.pin}]);
          setModal(null); showToast(`✅ ${form.name} added as staff member!`);
        }} style={{...btnP,width:"100%",padding:14,fontSize:15,borderRadius:12}}>Add Staff Member</button>
      </Modal>}

      {/* EDIT STAFF MODAL */}
      {modal==="editStaff"&&<Modal title="Edit Staff Member" onClose={()=>setModal(null)}>
        <Field label="FULL NAME" name="name" value={form.name||""} onChange={(n,v)=>setForm(p=>({...p,[n]:v}))}/>
        <div style={{marginBottom:15}}>
          <label style={{color:B.muted,fontSize:12,fontWeight:600,display:"block",marginBottom:5,letterSpacing:0.5}}>ROLE</label>
          <select value={form.role||"staff"} onChange={e=>setForm(p=>({...p,role:e.target.value}))} style={{...inpStyle,cursor:"pointer"}}
            disabled={form.id==="S001"}>
            <option value="staff">Staff — standard access</option>
            <option value="admin">Admin — full access</option>
          </select>
        </div>
        <Field label="NEW PIN (leave blank to keep current)" name="pin" type="password" value={form.pin||""} onChange={(n,v)=>setForm(p=>({...p,[n]:v}))} placeholder="Leave blank to keep current PIN"/>
        <button onClick={()=>{
          if(!form.name) return showToast("Name is required.","error");
          if(form.pin&&form.pin.length<4) return showToast("PIN must be at least 4 digits.","error");
          setStaffMembers(p=>p.map(s=>s.id===form.id?{...s,name:form.name,role:form.role,...(form.pin?{pin:form.pin}:{})}:s));
          // update logged in staff if editing self
          if(loggedInStaff?.id===form.id) setLoggedInStaff(prev=>({...prev,name:form.name,role:form.role,...(form.pin?{pin:form.pin}:{})}));
          setModal(null); showToast("✅ Staff member updated!");
        }} style={{...btnP,width:"100%",padding:14,fontSize:15,borderRadius:12}}>Save Changes</button>
      </Modal>}

      <Toast/>
    </div>
  );
}